import ViewBase from "../../view-base.view";

export default function NumericWidgetView() {
  ViewBase.call(this);
  let onClick = (type) => { }
  return {
    oninit: function (vnode) {
      if (vnode.attrs.onClick) {
        onClick = vnode.attrs.onClick;
      }
    },

    view: (vnode) => {
      return [
        m('.schedule-visit-rate.d-flex.flex-nowrap',
          m('.vr-group-data.bg-white', { onclick: () => { onClick("") } },
            m('div', { class: vnode.attrs.data.planStatus != "" ? "vr-data vr-data-primary vr-data-primary-bg-primary" : "vr-data vr-data-primary vr-data-primary-bg-primary-selected" },
              m('.font-size-0-75', this.getText("LT00000046", "Total")),
              m('.vr-value', vnode.attrs.data.total),
            )
          ),
          m('.vr-group-data.bg-white',
            m('div',
              {
                class: vnode.attrs.data.planStatus != "PlannedVisit" ? " vr-data vr-data-primary vr-data-primary-bg-primary" : "vr-data vr-data-primary vr-data-primary-bg-primary-selected",
                onclick: () => { onClick("PlannedVisit") }
              },
              m('.font-size-0-75', this.getText("LT00000176", "Planned")),
              m('.vr-value', vnode.attrs.data.planned_total),
            ),
            m('div',
              {
                class: vnode.attrs.data.planStatus != "CompletedVisit" ? "vr-data vr-data-secondary vr-data-secondary-bg-grey" : "vr-data vr-data-secondary vr-data-secondary-bg-grey-selected",
                onclick: () => { onClick("CompletedVisit") }
              },
              m('.font-size-0-75', this.getText("LT00000177", "Completed")),
              m('.vr-value', vnode.attrs.data.planned_completed),
            ),
            m('div',
              {
                class: vnode.attrs.data.planStatus != "InProgressVisit" ? "vr-data vr-data-secondary vr-data-secondary-bg-orange" : "vr-data vr-data-secondary vr-data-secondary-bg-orange-selected",
                onclick: () => { onClick("InProgressVisit") }
              },
              m('.font-size-0-75', this.getText("LT00000178", "In-Progress")),
              m('.vr-value', vnode.attrs.data.planned_inprogress),
            ),
            m('div',
              {
                class: vnode.attrs.data.planStatus != "NotVisited" ? "vr-data vr-data-secondary vr-data-secondary-bg-red" : "vr-data vr-data-secondary vr-data-secondary-bg-red-selected",
                onclick: () => { onClick("NotVisited") }
              },
              m('.font-size-0-75', this.getText("LT00000179", "Not Visited")),
              m('.vr-value', vnode.attrs.data.planned_notvisited),
            ),
          ),
          m('.vr-group-data.bg-white',
            { onclick: () => { onClick("UnplannedVisit") } },
            m('div',
              {
                class: vnode.attrs.data.planStatus != "UnplannedVisit" ? "vr-data vr-data-primary vr-data-primary-bg-primary" : "vr-data vr-data-primary vr-data-primary-bg-primary-selected",
              },
              m('.font-size-0-75', this.getText("LT00000180", "Unplanned")),
              m('.vr-value', vnode.attrs.data.unplanned_total),
            )
          ),
        ),
        this.getBaseViews()
      ]
    }
  }
}
